__turbopack_context__.v({
  "chev": "services-bento-module__TPi68q__chev",
  "chevIcon": "services-bento-module__TPi68q__chevIcon",
  "manifest": "services-bento-module__TPi68q__manifest",
  "num": "services-bento-module__TPi68q__num",
  "row": "services-bento-module__TPi68q__row",
  "rowInner": "services-bento-module__TPi68q__rowInner",
  "table": "services-bento-module__TPi68q__table",
  "title": "services-bento-module__TPi68q__title",
  "viewAll": "services-bento-module__TPi68q__viewAll",
  "viewAllBtn": "services-bento-module__TPi68q__viewAllBtn",
  "wrap": "services-bento-module__TPi68q__wrap",
});
